export default {"src":"/_next/static/media/WhoWeAre_037A.bad221ea.JPG","height":700,"width":1920};